module.exports = __webpack_public_path__ + "img/parents.86aad32.jpg";